import type { EvaluationResultsErrorResponse, TranscriptContent } from "../api/evaluations/types";

import { TrainingSessionChallengeResultStatus } from "../types";

function isTrainingSessionChallengeResultStatus(value: unknown): value is TrainingSessionChallengeResultStatus {
    return (Object.values(TrainingSessionChallengeResultStatus) as unknown[]).includes(value);
}

// `Partial<TranscriptContent>` so the shapes that only *may* carry a verdict — the `already_completed`
// replay, and a polled session record — can use the same guard.
export function isEvaluationTranscriptContent(
    data: Partial<TranscriptContent> | EvaluationResultsErrorResponse,
): data is TranscriptContent {
    if (!("EvaluationDetails" in data)) return false;
    // Key presence alone admitted `null` — and anything else the unvalidated passthrough puts there —
    // to callers that immediately read `.Results` / `.Body` off it. Deliberately stops at "is an
    // object": requiring a populated verdict would change which records render.
    const details: unknown = data.EvaluationDetails;
    return typeof details === "object" && details !== null;
}

export function getChallengeResults(status?: string): TrainingSessionChallengeResultStatus {
    const maybe = status?.toLocaleLowerCase();
    if (isTrainingSessionChallengeResultStatus(maybe)) return maybe;

    return TrainingSessionChallengeResultStatus.NOT_AVAILABLE;
}

export function isValidHttpUrl(text: string) {
    try {
        const url = new URL(text);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch {
        return false;
    }
}
